import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';

/**
 * Redirect for legacy /sync/* and /scheduler/* URLs.
 * Preserves query string and location state (DiffExplorer passes
 * preselected SKUs to Manual Sync via state, for example).
 *
 * `to` is either a path string or a function of route params.
 */
const LegacyRedirect = ({ to }) => {
  const location = useLocation();
  const params = useParams();
  const pathname = typeof to === 'function' ? to(params) : to;
  return (
    <Navigate
      to={{ pathname, search: location.search }}
      state={location.state}
      replace
    />
  );
};

export default LegacyRedirect;
